import {
  SCALE_DEFINITIONS,
  scaleRules,
  scaleRulesAvailable,
} from './definitions';

const getLegsScalesByLeg = cluster =>
  cluster.legs.map(leg => leg.options?.map(o => o.scales_qty) ?? []);

export const filterSimpleByScale = (clusters, scaleSelected) => {
  if (!scaleSelected || scaleSelected === 'allOptions') return [...clusters];

  const rule = scaleRules[scaleSelected];
  if (!rule) return [...clusters];

  return clusters.filter(cluster => {
    const legsScales = getLegsScalesByLeg(cluster);
    const result = rule(legsScales);

    return result;
  });
};

export const getClusterScales = clusters => {
  const filtered = Object.entries(scaleRulesAvailable).filter(
    ([_key, rule]) => {
      const result = clusters.some(cluster => {
        return rule(getLegsScalesByLeg(cluster));
      });

      return result;
    }
  );

  return [
    { name: 'Todas las opciones', value: 'allOptions' },
    ...filtered.map(([key]) => ({
      value: key,
      name: SCALE_DEFINITIONS[key].label,
    })),
  ];
};
